"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditIcon = void 0;
/* eslint-disable max-len */
var react_1 = __importStar(require("react"));
var Icon_1 = require("./Icon");
exports.EditIcon = (0, react_1.forwardRef)(function EditIcon(props, ref) {
    return (react_1.default.createElement(Icon_1.Icon, __assign({ ref: ref, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { d: "M14.7929 7.36817L6.43286 15.7282C6.25275 15.9076 6.10851 16.1197 6.00786 16.3532L4.27986 19.5202L7.64486 17.9902C7.87786 17.8892 8.08986 17.7452 8.26886 17.5662L16.6289 9.20417C16.4031 8.82927 16.1298 8.48509 15.8159 8.18017C15.5112 7.86666 15.1673 7.59374 14.7929 7.36817ZM16.2389 5.92217C16.5739 6.15917 16.9039 6.44117 17.2299 6.76617C17.5559 7.09217 17.8379 7.42317 18.0749 7.75817L19.5459 6.28717C19.6155 6.21767 19.663 6.12917 19.6826 6.03276C19.7022 5.93635 19.6929 5.83631 19.6559 5.74517C19.5489 5.48317 19.3579 5.20817 19.0739 4.92317C18.7889 4.63917 18.5139 4.44817 18.2519 4.34117C18.1607 4.30415 18.0607 4.29484 17.9643 4.31441C17.8679 4.33397 17.7794 4.38155 17.7099 4.45117L16.2399 5.92217H16.2389ZM4.16986 15.5642C4.37057 15.0974 4.65837 14.6732 5.01786 14.3142L16.2959 3.03617C16.6433 2.68863 17.0855 2.4512 17.5671 2.35356C18.0488 2.25591 18.5485 2.30239 19.0039 2.48717C19.5299 2.70117 20.0239 3.04417 20.4879 3.50817C20.9519 3.97317 21.2959 4.46717 21.5079 4.99217C21.6928 5.44744 21.7394 5.94712 21.6419 6.42875C21.5445 6.91038 21.3072 7.3526 20.9599 7.70017L9.68386 18.9802C9.32474 19.3393 8.90052 19.6268 8.43386 19.8272L4.99186 21.3072C4.67028 21.4456 4.31455 21.4844 3.97068 21.4186C3.62681 21.3527 3.31059 21.1853 3.06291 20.9378C2.81523 20.6903 2.64747 20.3743 2.58132 20.0304C2.51517 19.6866 2.55368 19.3309 2.69186 19.0092L4.16986 15.5642Z", fill: "currentColor" })));
});
